import { SortItem } from './member.dashboard.license.response';

export class BillingCredit {
    MemberID: number;
    FirstName: string;
    LastName: string;
    Email: string;
    Credit: number;
}

export class BillingCreditsArray extends Array<BillingCredit> {
    public LastSort: SortItem;

    constructor(...items: BillingCredit[]) {
        super(...items);
        Object.setPrototypeOf(this, BillingCreditsArray.prototype);
    }

}
